// extracted by mini-css-extract-plugin
export default {"wrapper":"ts-z","response":"us-z","error":"vs-z","disabled":"ws-z","buttons":"xs-z","feedbackQuestionSection":"ys-z","yesNoWrapper":"zs-z"};